/*
 * @Author: your name
 * @Date: 2019-12-10 22:17:21
 * @LastEditTime : 2020-01-12 12:03:21
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\untils\request.js
 */
import Axios from 'Axios'
import { Toast } from 'mint-ui';//遮罩层还有提示
import { Loading } from 'element-ui';
const service = Axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
})
let loadingInstance = null;
service.interceptors.request.use(
    config => {
        loadingInstance = Loading.service();
        return config;
    },
    err => {
        Toast({
            message: '网络错误',
            position: 'middle',
            duration: 3000
        });
        return Promise.reject(err);;
    }
)
service.interceptors.response.use(
    data => {
        loadingInstance.close();
        return data.data;
    },
    err => {
        loadingInstance.close();
        return Promise.reject(err);
    }
)
export default service;


// WEBPACK FOOTER //
// ./src/untils/request.js